import { xhrStatusFactory } from 'redux/reusable/xhrStatus';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { uniqBy } from 'utils/typesafe';
import type { State } from './users.types';
import * as types from './users.types';
import { usersXhrModule } from './users.types';

const { withXhrStatusReducer } = usersXhrModule;

export const initialState: State = {
  xhrStatus: xhrStatusFactory(),
  entries: [],
  searchResults: [],
};

const reducer = reducerWithInitialState<State>(initialState)
  .caseWithAction(types.fetched, (state, action) => ({
    ...state,
    entries: action.payload,
  }))
  .caseWithAction(types.fetchedPartial, (state, action) => {
    const entries = state.entries.map(user => {
      const updatedUser = action.payload.find(u => u.id === user.id);
      if (updatedUser) {
        return updatedUser;
      }
      return user;
    });
    const existingUserIds = entries.map(user => user.id);

    // Merge new users with existing
    action.payload.forEach(user => {
      if (!existingUserIds.includes(user.id)) {
        entries.push(user);
      }
    });

    return {
      ...state,
      entries,
    };
  })
  .caseWithAction(types.addUser, (state, action) => {
    const filterFromState = state.entries.filter(u => u.id !== action.payload.id);
    return {
      ...state,
      entries: [...filterFromState, action.payload],
    };
  })
  .caseWithAction(types.removeUser, (state, action) => ({
    ...state,
    entries: state.entries.map(u => (u.id !== action.payload ? u : { ...u, deleted: true })),
  }))
  .caseWithAction(types.updateUser, (state, action) => {
    const users = state.entries.map(user => {
      return user.id !== action.payload.id ? user : { ...user, ...action.payload };
    });

    return {
      ...state,
      entries: users,
    };
  })
  .caseWithAction(
    types.fetchedSearchResults,
    (state, action): State => ({
      ...state,
      searchResults: uniqBy(state.searchResults.concat(action.payload), user => user.id),
    })
  )
  .case(
    types.clearSearchResults,
    (state): State => ({
      ...state,
      searchResults: [],
    })
  );

export default withXhrStatusReducer(reducer);
